// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info-box h6[data-v-0951c975]:first-child {\n  font-size: var(--fs-input) !important;\n  color: var(--dark-green-50, #809795);\n  font-weight: 400 !important;\n}\n.info-box h6[data-v-0951c975] {\n  font-size: var(--fs-input) !important;\n  color: var(--green);\n  font-weight: 400 !important;\n}", ""]);
// Exports
module.exports = exports;
